<div style="width: 100%;">
    <div class="controls">
        <button mat-stroked-button color="primary" (click)="getSinonimos()" [disabled]="submiting">
            <mat-icon>refresh</mat-icon>
            Carregar dados
        </button>
    </div>

    <ng-container *ngIf="submiting">
        <div class="empty-content" style="width: 100%">
            <mat-progress-spinner mode="indeterminate" diameter="30"></mat-progress-spinner>
        </div>
    </ng-container>
    <ng-container *ngIf="submiting == false">

        <ng-container *ngIf="datasource.data == null">
            <div class="empty-content" style="width: 100%">
                Resultado do filtro aparecerá aqui
            </div>
        </ng-container>

        <ng-container *ngIf="datasource.data && datasource.data.length == 0">
            <div class="empty-content" style="width: 100%">
                Nenhum resultado encontrado!
            </div>
        </ng-container>

        <ng-container *ngIf="datasource.data && datasource.data.length > 0">

            <mat-grid-list [cols]="2">
                <mat-grid-tile>
                    <div style="flex: 1" class="table-container" [ngStyle]="{height: (pieChartWidth - 100) + 'px' }">
                        <table class="table" mat-table [dataSource]="datasource">
                            <ng-container *ngFor="let attr of displayedColumns">
                                <ng-container [matColumnDef]="attr">
                                    <th mat-header-cell *matHeaderCellDef>
                                        <span class="th-wrapper">
                                            {{ columnsDisplayName[attr] }}
                                        </span>
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ element[attr] }}
                                    </td>
                                </ng-container>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns" style="cursor: pointer"></tr>
                        </table>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile #pieChartContainer>
                    <div style="margin: auto" [ngStyle]="{ height: (pieChartWidth) + 'px'}">
                        <h2 style="padding: 10px">20 principais cargos</h2>
                        <div style="width: 100%">
                            <ngx-charts-bar-horizontal [view]="[pieChartWidth, pieChartWidth - 100]"
                                [results]="pieChartData" [gradient]="false" [xAxis]="true" [yAxis]="true"
                                [legend]="false" [showXAxisLabel]="true" [showYAxisLabel]="true"
                                xAxisLabel="Quantidades" yAxisLabel="Cargos">
                            </ngx-charts-bar-horizontal>
                        </div>
                    </div>
                </mat-grid-tile>
            </mat-grid-list>
        </ng-container>

    </ng-container>

</div>